import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { fadeInOut } from '../../services/animations';
import { ConfigurationService } from '../../services/configuration.service';
import { ContractBaseService } from '../../services/contract-base.service';
import { CustomersService } from '../../services/customers.service';
import { DashboardViewModel } from './../../models/dashboard-view-model';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')],
    animations: [fadeInOut]
})
export class HomeComponent implements OnDestroy {
    private subscribers: Subscription[] = [];
    dashboardViewModel: DashboardViewModel;
    contractsCount: number = 0;
    customersCount: number = 0;
    isLoadingLastUpdateDate: boolean = false;

    isLoadingloadingcontractsCount: boolean = false;
    isLoadingloadingcustomersCount: boolean = false;

    constructor(private accountService: AccountService, public configurations: ConfigurationService, private customersService: CustomersService, private router: Router, private ngxLogger: NGXLogger,
        private contractBaseService: ContractBaseService) {
    }

    ngOnInit() {
        this.isLoadingLastUpdateDate = true;
        this.dashboardViewModel = new DashboardViewModel();

        const dashboardDateSubscriber = this.accountService.getDashboardDates()
            .subscribe(res => {
                this.dashboardViewModel = res;
                this.isLoadingLastUpdateDate = false;
            }, error => {
                this.isLoadingLastUpdateDate = false;
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(dashboardDateSubscriber);

        const getCountSubscriber = this.contractBaseService.getCount()
            .subscribe((res: number) => {
                this.contractsCount = res;
                this.isLoadingloadingcontractsCount = false;
            }, error => {
                this.isLoadingloadingcontractsCount = false;
                this.ngxLogger.error(error.message);
            });
        this.subscribers.push(getCountSubscriber);

        const getCustCountSubscriber = this.customersService.getCount()
            .subscribe((res: number) => {
                this.customersCount = res;
                this.isLoadingloadingcustomersCount = false;
            }, error => {
                this.isLoadingloadingcustomersCount = false;
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getCustCountSubscriber);
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    navigateBelpexOverview() {
        this.router.navigate(['belpex']);
    }

    navigateGasThreeOverview() {
        this.router.navigate(['gasthree']);
    }

    navigateElectricityOverview() {
        this.router.navigate(['electricity']);
    }

    navigateGasOverview() {
        this.router.navigate(['gas']);
    }

    navigateCoalOverview() {
        this.router.navigate(['coal']);
    }

    navigateOilOverview() {
        this.router.navigate(['oil']);
    }

    navigateCoTwoOverview() {
        this.router.navigate(['cotwo']);
    }

    navigateGasTwoOverview() {
        this.router.navigate(['gastwo']);
    }

    navigateCustomerOverview() {
        this.router.navigate(['customers']);
    }

    get canmanageDashboardPermission() {
        return this.accountService.userHasPermission(Permission.manageDashboardPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/home/home.component.ts